

function Programs() {
    
    return (
        <div className="programs-div bg-stone-50 pr-5 mb-[-8rem]">

            {/* Title Section */}
            <div className="join-title text-center pt-20">
                <h1 className="join-title text-5xl font-bold text-olive">A Journey of Growth and Faith</h1>
            </div>

            <div className="programs-text">
                <h1 className="programs-subtext text-base font-semibold text-navy mt-2 text-center pb-10 pl-10">
                    We offer developmentally appropriate programs for children aged 6 weeks to 4 years that inspire confidence, curiosity, and Christ-like character:
                </h1>

                {/* Top Programs Section */}
                <div className="programs-text-div justify-center flex flex-col sm:flex-row sm:space-x-8 sm:pl-9 pt-20 sm:space-y-0 space-y-8 sm:space-x-8 lg:-mt-10 lg:pb-40">
                    <div className="program-li-div text-center lg:flex lg:flex-col lg:items-center lg:justify-center lg:w-1/3">
                        <h1 className="text-base font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out mb-5">
                            Infant (6 weeks - 12 months)
                        </h1>
                        <img 
                            rel="preload" 
                            src="/assets/photos/HFH09176.jpg" 
                            alt="Infants" 
                            className="program-li-img-one mb-4 mx-auto h-2/5 rounded-xl lg:h-auto lg:w-1/2" 
                        />
                        <h2 className="program-li-text text-default mb-20 text-gray-700 max-w-[600px] mx-auto">
                            Our Infant Program provides a loving, faith-centered environment where babies are nurtured through gentle, structured care inspired by the Abeka Curriculum. Through songs, sensory play, and meaningful interactions, infants begin developing early language, cognitive, and motor skills while experiencing daily prayer, music, and Christian love.
                        </h2>
                    </div>

                    <div className="program-li-div-two text-center lg:flex lg:flex-col lg:items-center lg:justify-center lg:w-1/3 transform translate-y-[-80px] lg:translate-y-[-rem]">
                        <h1 className="text-base font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out mb-5">
                            Young Toddler (12 - 23 months)
                        </h1>
                        <img 
                            rel="preload" 
                            src="/assets/photos/HFH09259.jpg" 
                            alt="Toddlers" 
                            className="program-li-img-two mb-4 mx-auto h-2/5 rounded-xl lg:h-auto lg:w-1/2"
                        />
                        <h2 className="program-li-text mb-6 text-default text-gray-700 max-w-[550px] mx-auto">
                            Our Young Toddler Program encourages independence through hands-on learning, music, repetition, and guided play inspired by the Abeka Curriculum. Children develop early language and comprehension skills while learning Christian values like kindness, patience, and sharing in a nurturing environment.
                        </h2>
                    </div>
                    
                </div>

                {/* Middle Programs Section */}
                <div className="programs-text-div flex flex-col sm:flex-row sm:space-x-8 sm:pl-9 sm:space-y-0 space-y-8 lg:-mt-20 lg:pb-40">
                    <div className="program-li-div text-center lg:flex lg:flex-col lg:items-center lg:justify-center lg:w-full">
                        <h1 className="text-base font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out mb-5">
                            Two-Year-Old (34 - 35 months)
                        </h1>
                        <img 
                            rel="preload" 
                            src="/assets/photos/HFH09387.jpg" 
                            alt="Two-Year-Old" 
                            className="different-points-image-pro mb-4 mx-auto h-2/5 rounded-xl lg:h-auto lg:w-3/4" 
                        />
                        <h2 className="program-li-text text-default mb-20 text-gray-700 max-w-[500px] mx-auto">
                            The Two-Year-Old Program helps children build confidence and curiosity through structured, faith-based learning. Using the Abeka Curriculum, students are introduced to colors, shapes, numbers, and language skills through interactive activities, while daily prayer and positive guidance encourage kindness, cooperation, and independence.
                        </h2>
                    </div>

                    <div className="program-li-div-two text-center lg:flex lg:flex-col lg:items-center lg:justify-center lg:w-full transform translate-y-[-80px] lg:translate-y-[-2rem]">
                        <h1 className="text-base font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out mb-5">
                            Preschool (3-Year-Olds)
                        </h1>
                        <img 
                            rel="preload" 
                            src="/assets/photos/HFH08808.jpg" 
                            alt="Preschool" 
                            className="program-li-img-two mb-4 mx-auto h-2/5 rounded-xl lg:h-auto lg:w-1/2"
                        />
                        <h2 className="program-li-text text-default text-gray-700 max-w-[390px] mx-auto">
                            Our Preschool Program builds a strong academic and spiritual foundation through the Abeka Curriculum. Children develop early literacy, math, and problem-solving skills through engaging instruction, hands-on STEM activities, Bible lessons, prayer, and character-building experiences.
                       </h2>
                    </div>

                    <div className="program-li-div text-center lg:flex lg:flex-col lg:items-center lg:justify-center lg:w-full lg:mb-20">
                        <h1 className="text-base font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out mb-5">
                            Advanced Preschool (4-Year-Olds)
                        </h1>
                        <img 
                            rel="preload" 
                            src="/assets/photos/HFH09631.jpg" 
                            alt="Advanced Preschool" 
                            className="different-points-image-pro mb-4 mx-auto h-full rounded-xl lg:h-auto lg:w-3/4" 
                        />
                        <h2 className="program-li-text text-default mb-40 text-gray-700 max-w-[500px] mx-auto">
                            The Advanced Preschool Program provides a challenging, kindergarten-prep experience using the Abeka Curriculum. Students strengthen literacy, writing, math, and critical thinking skills through structured lessons, hands-on STEM activities, and daily faith-based learning that promotes confidence and Christian values.
                        </h2>
                    </div>
                    
                </div>

                {/* Bottom Programs Section */}
                <div className="programs-text-div justify-center flex flex-col sm:flex-row sm:space-x-8 sm:pl-9 mb-10 pb-40 sm:space-y-0 space-y-8 sm:space-x-8 lg:-mt-40">
                    <div className="program-li-div text-center lg:flex lg:flex-col lg:items-center lg:justify-center lg:w-1/3">
                        <h1 className="text-base font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out mb-5">
                            GA Pre-Kindergarten (Aug 2026)
                        </h1>
                        {/* <img 
                            rel="preload" 
                            src="/assets/photos/HFH00142.jpg" 
                            alt="Infants" 
                            className="program-li-img-one mb-4 mx-auto h-2/5 rounded-xl lg:h-auto lg:w-1/2" 
                        /> */}
                        <h2 className="program-li-text text-default mb-20 text-gray-700 max-w-[500px] mx-auto">
                            Our Georgia Pre-K Program at Wonder Kids Academy is a state-funded program that prepares 4-year-olds for kindergarten through hands-on learning, academic readiness, and social-emotional development in a safe, nurturing environment. The classroom follows Georgia DECAL standards and provides engaging, age-appropriate instruction that builds confidence, creativity, independence, and a love for learning.
                        </h2>
                    </div>

                    <div className="program-li-div-two text-center lg:flex lg:flex-col lg:items-center lg:justify-center lg:w-1/3 transform translate-y-[-80px] lg:translate-y-[-rem]">
                        {/* <h1 className="text-base font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out mb-5">
                            Christian Kindergarten (Aug 2026)
                        </h1>
                        {/* <img 
                            rel="preload" 
                            src="/assets/photos/HFH05001.jpg" 
                            alt="Toddlers" 
                            className="program-li-img-two mb-4 mx-auto h-2/5 rounded-xl lg:h-auto lg:w-1/2"
                        /> */}
                        {/* <h2 className="program-li-text text-default text-gray-700 max-w-[500px] mx-auto">
                             The Christian Kindergarten Program combines strong academics with faith-based learning through the Abeka Curriculum. Students develop reading, writing, math, science, and critical thinking skills through direct instruction, hands-on learning, STEM exploration, and daily Bible-centered character development.
                        </h2> */} 
                    </div>
                    
                </div>

            </div>
        </div>
    );
}

export default Programs;
